import { useState } from "react";
import "../styles/newsletter.css";
import { CheckCircle, Send } from "lucide-react";
import newsletterAPI from "../api/newsletterAPI";
import toast from "react-hot-toast";

export default function Newsletter() {
  const [mode, setMode] = useState("subscribe"); // "subscribe" | "unsubscribe"
  const [form, setForm] = useState({ name: "", email: "" });
  const [nlSent, setNlSent] = useState(false);
  const [nlMsg, setNlMsg] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function switchMode(newMode) {
    setMode(newMode);
    setNlSent(false);
    setForm({ name: "", email: "" });
  }

  const onNl = async (e) => {
    e.preventDefault();
    if (mode === "subscribe" && (!form.name.trim() || !form.email.trim()))
      return;
    if (mode === "unsubscribe" && !form.email.trim()) return;

    try {
      if (mode === "subscribe") {
        const res = await newsletterAPI.subscribe({
          fullName: form.name,
          email: form.email,
        });
        console.log("Newsletter subscribe response:", res);
        setNlMsg(res?.message || "Subscribed! Jai Shri Krishna 🙏");
      } else {
        const res = await newsletterAPI.unsubscribe({ email: form.email });
        console.log("Newsletter unsubscribe response:", res);
        setNlMsg(res?.message || "Unsubscribed successfully.");
      }
      setNlSent(true);
    } catch (err) {
      toast.error(`Newsletter ${mode} failed:`, err?.response.data?.message);
    }
  };

  return (
    <section className="iskcon-newsletter-section iskcon-newsletter-section--dark">
      <div className="container">
        <div className="iskcon-newsletter-center">
          <span className="iskcon-newsletter-eyebrow">Stay Connected</span>
          <h2 className="iskcon-newsletter-heading">
            Subscribe <span>Newsletters</span>
          </h2>
          <p className="iskcon-newsletter-sub">
            Receive spiritual updates, event announcements, and devotional
            content delivered regularly to your inbox.
          </p>

          <div className="iskcon-newsletter-toggle">
            <button
              type="button"
              className={mode === "subscribe" ? "active" : ""}
              onClick={() => switchMode("subscribe")}
            >
              Subscribe
            </button>
            <button
              type="button"
              className={mode === "unsubscribe" ? "active" : ""}
              onClick={() => switchMode("unsubscribe")}
            >
              Unsubscribe
            </button>
          </div>

          {nlSent ? (
            <div className="iskcon-newsletter-ok">
              <CheckCircle size={16} />
              {nlMsg}
            </div>
          ) : (
            <form className="iskcon-newsletter-row" onSubmit={onNl}>
              {mode === "subscribe" && (
                <input
                  className="iskcon-newsletter-inp"
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              )}
              <input
                className="iskcon-newsletter-inp"
                type="email"
                name="email"
                placeholder="Email Address"
                value={form.email}
                onChange={handleChange}
                required
                style={{ borderRight: "none" }}
              />
              <button type="submit" className="iskcon-newsletter-sbtn">
                {mode === "subscribe" ? "Subscribe" : "Unsubscribe"}{" "}
                <Send size={12} />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
